import { isValidPhoneNumber } from "libphonenumber-js";
export const isValidUsPhoneNumber = (phoneNumber) => {
    return isValidPhoneNumber(phoneNumber, "US");
};
// Display-only title case for option labels and brand/model text (LW-1534).
// Per word segment: alphanumeric codes are upper-cased ("5007f" -> "5007F"),
// intentional mixed case is kept ("iPhone", "DeWalt"), and anything else is
// capitalized ("BLACK & decker" -> "Black & Decker"). Render-time only — never
// write the result back into state, so API payloads stay unchanged.
const isMixedCase = (word) => /\p{Ll}/u.test(word) && /\p{Lu}/u.test(word.slice(1));
export const toDisplayTitleCase = (value) => value.replace(/[^\s\-/(&]+/g, (word) => {
    if (/\d/.test(word))
        return word.toUpperCase();
    if (isMixedCase(word))
        return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
});
export const resolvePromiseWithError = async (error, url = null, config = null) => {
    return await Promise.resolve({
        data: null, error
    });
};
export const resolvePromiseWithSuccess = async (data = null) => {
    return await Promise.resolve({
        data: data, error: null
    });
};
export const getRequestUrlWithParams = (path, params) => {
    if (!path)
        return null;
    const baseUrl = getGlobalVal('API_BASE_URL');
    if (!baseUrl)
        return null;
    let dataRequestUrl = `${baseUrl}/${path}`;
    if (params && params instanceof Object) {
        const tmpParams = Object.entries(params)
            .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&');
        dataRequestUrl += dataRequestUrl.includes('?') ? '&' : '?' + tmpParams;
    }
    return dataRequestUrl;
};
export const loadScript = (id, src, parent = document.body, async = true) => {
    return new Promise((resolve, reject) => {
        if (document.getElementById(id) != null) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.async = async;
        script.setAttribute('id', id);
        script.setAttribute('src', src);
        script.setAttribute('type', 'text/javascript');
        parent.appendChild(script);
        script.onload = () => resolve();
    });
};
export const loadStyle = (id, src, parent = document.head) => {
    if (document.getElementById(id) != null) {
        return;
    }
    const style = document.createElement('link');
    style.setAttribute('id', id);
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', src);
    parent.appendChild(style);
    return style;
};
export const cleanElementId = (elementId) => {
    return elementId.replace(/-/g, '_');
};
export const getGlobalVal = (varName) => {
    if (!window.EZ)
        return null;
    let value = null;
    try {
        let jsonData = JSON.parse(atob(window.EZ));
        value = jsonData[varName];
    }
    catch (error) {
        console.error('Global config values not found.', window.EZ);
    }
    return value;
};
// deployment environment served by ez-env-vars, lowercased; "undefined" when the app setting is missing
export const getEnvName = () => {
    var _a;
    const env = String((_a = getGlobalVal('ENV')) !== null && _a !== void 0 ? _a : '').trim().toLowerCase();
    return env && env !== 'undefined' ? env : null;
};
// only non-prod environments are labelled in the UI so customers never see a badge
const NON_PROD_ENVS = ['local', 'localhost', 'dev', 'development', 'qa', 'stg', 'stage', 'staging', 'uat'];
export const getNonProdEnvName = () => {
    const env = getEnvName();
    return env && NON_PROD_ENVS.includes(env) ? env : null;
};
export const CATEGORY_DISPLAY_ORDER = [
    "Video Game Consoles",
    "Laptops",
    "Tablets",
    "Smart Phones",
    "Digital Led TVs",
    "Smart Watches",
    "Portable Speakers",
    "Desktops",
    "Portable Video Game Systems",
    "Headphones",
    "Earbuds",
    "Gaming Controllers",
    "Car Woofer/ Sub-Woofer Speakers",
    "Virtual reality devices"
];
export const getCookieValue = (name) => {
    var _a;
    const value = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    return value ? decodeURIComponent(value) : null;
};
